






















import Spinner from '@/components/Spinner.vue';

export default {
  props: {
    maxPageDisplay: {
      type: Number,
      default: 4,
    },
    pageCount: {
      type: Number,
      default: 1,
    },
    recordCount: Number,

    // pageNumber
    value: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value: number) {
        this.$emit('input', value);
      },
    },
  },
  components: {
    Spinner,
  },
} as IView;
